/* eslint-disable max-lines */
import { DrawerHeader, IconButton } from '@one-thd/sui-atomic-components';
import { ArrowBack, Close } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { SubmitDeliveryAddressSuspendCart } from '../../../api/oms/edit-delivery-address';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { EditDeliveryAddressChangeForm } from './EditDeliveryAddressChangeForm';
import { EditDeliveryAddressDeliveryDetails } from './EditDeliveryAddressDeliveryDetails';
import { EditDeliveryAddressConfirmation } from './EditDeliveryAddressConfirmation';
import { EditDeliveryAddressSurvey } from './EditDeliveryAddressSurvey';
import { EditDeliveryAddressConfirmationBODFS } from './BodfsConfirmation/EditDeliveryAddressConfirmationBODFS';
import { getWindow } from '../../../utils/general';
import { useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { extractAddressFromFulfillmentGroup } from '../../../utils/order-details/OrderDetailsUtils';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { getFlowTypeValue } from '../util/OutOfStock';
import { getCookieValue } from '../../../utils/cookie-helper';
import { mapLineIds, goBackToChangeForm, goBackToDeliveryDetails, goBackToDeliveryOptions, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
import { EditDeliveryAddressDeliveryOptions } from './EditDeliveryAddressDeliveryOptions';
export var EditDeliveryAddressDrawerContent = function (_a) {
    var _b, _c;
    var setOpen = _a.setOpen, setShowDrawerError = _a.setShowDrawerError, isBopisOutOfStock = _a.isBopisOutOfStock, isOuterClick = _a.isOuterClick, setIsOuterClick = _a.setIsOuterClick;
    var _d = useFulfillmentGroupContext(), fulfillmentGroup = _d.fulfillmentGroup, fulfillmentType = _d.fulfillmentType;
    var _e = useOrderContext(), currentDrawer = _e.currentDrawer, setCurrentDrawer = _e.setCurrentDrawer, orderDetailsData = _e.orderDetailsData, orderId = _e.orderId, setDeliveryInstructions = _e.setDeliveryInstructions, setDeliveryAddresses = _e.setDeliveryAddresses, setShowCalendar = _e.setShowCalendar, setRequireSignature = _e.setRequireSignature;
    var _f = useState(true), isChangeForm = _f[0], setIsChangeForm = _f[1];
    var _g = useState(false), isDeliveryDetails = _g[0], setIsDeliveryDetails = _g[1];
    var _h = useState(false), isConfirmation = _h[0], setIsConfirmation = _h[1];
    var _j = useState(false), isSurvey = _j[0], setIsSurvey = _j[1];
    var _k = useState(false), enteredEditFlow = _k[0], setEnteredEditFlow = _k[1];
    var _l = useState(Boolean(FeatureSwitches.enableEditDeliveryAddressAppify)), isAddressList = _l[0], setIsAddressList = _l[1];
    var _m = useState(false), isDeliveryOptions = _m[0], setIsDeliveryOptions = _m[1];
    var _o = useState(null), selectedDeliveryOptionType = _o[0], setSelectedDeliveryOptionType = _o[1];
    // Stores info for re-load of OD page in session storage to determine what (if any) Alerts to render
    var _p = useState(), editDeliveryAddressAlert = _p[0], setEditDeliveryAddressAlert = _p[1];
    var _q = useState(), suspendCartData = _q[0], setSuspendCartData = _q[1];
    var _r = useState(false), isAddressChangeConfirmed = _r[0], setIsAddressChangeConfirmed = _r[1];
    var _s = useState(), updatedAddressData = _s[0], setUpdatedAddressData = _s[1];
    var _t = useState({}), newDeliveryAddressDetails = _t[0], setNewDeliveryAddressDetails = _t[1];
    // Change Form values (stored here as any change made needs to be retained while in flow)
    var _u = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentType), firstName = _u.firstName, lastName = _u.lastName, addressLine1 = _u.addressLine1, addressLine2 = _u.addressLine2, zipCode = _u.zipCode, city = _u.city, state = _u.state, phoneNumber = _u.phoneNumber, country = _u.country;
    var _v = useState(''), firstNameValue = _v[0], setFirstName = _v[1];
    var _w = useState(''), lastNameValue = _w[0], setLastName = _w[1];
    var _x = useState(''), streetAddressValue = _x[0], setStreetAddress = _x[1];
    var _y = useState(null), addressLineTwoValue = _y[0], setAddressLineTwo = _y[1];
    var _z = useState(''), zipCodeValue = _z[0], setZipCode = _z[1];
    var _0 = useState(''), cityStateValue = _0[0], setCityState = _0[1];
    var _1 = useState(''), phoneNumberValue = _1[0], setPhoneNumber = _1[1];
    var _2 = useState(false), isDefaultValue = _2[0], setIsDefault = _2[1];
    var _3 = useState(false), isLoading = _3[0], setIsLoading = _3[1];
    var _4 = useState(false), isExcludedAddress = _4[0], setIsExcludedAddress = _4[1];
    var _5 = useState(true), isValidated = _5[0], setIsValidated = _5[1];
    var _6 = useState(false), submitCreateForm = _6[0], setSubmitCreateForm = _6[1];
    var _7 = useState(''), validationEt = _7[0], setValidationEt = _7[1];
    var _8 = useState(false), isAddNewAddressFlow = _8[0], setIsAddNewAddressFlow = _8[1];
    var resetBodfsFlow = function () {
        setDeliveryInstructions('');
        setShowCalendar(false);
        setRequireSignature(false);
    };
    var flowType = getFlowTypeValue(currentDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var deliveryAddressCreateCartRequestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        firstName: firstNameValue,
        lastName: lastNameValue,
        phoneNumber: phoneNumberValue,
        emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
        fulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
        storeId: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentStore) || '',
        lineIds: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            ? mapLineIds(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            : [],
        newDeliveryAddress: {
            addressLine1: streetAddressValue || '',
            addressLine2: addressLineTwoValue || null,
            city: cityStateValue.split(',')[0],
            state: (_c = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _c === void 0 ? void 0 : _c.trim(),
            zipCode: zipCodeValue,
            country: country,
        },
        forterToken: getCookieValue('forterToken') || '',
        net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
        et: validationEt || '',
        flowType: flowType,
    };
    var setChangeFormValues = function () {
        if (!currentDrawer) {
            setFirstName(firstName);
            setLastName(lastName);
            setStreetAddress(addressLine1);
            setAddressLineTwo(addressLine2);
            setZipCode(zipCode);
            setCityState("".concat(city, ", ").concat(state));
        }
        setPhoneNumber(phoneNumber);
    };
    var suspendCartCheck = function () {
        if (suspendCartData && !isAddressChangeConfirmed) {
            SubmitDeliveryAddressSuspendCart(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    // Handles all logic associated with closing drawer
    // Should always be invoked instead of directly invoking setOpen(false)
    var closeDrawer = function () {
        var _a, _b;
        resetBodfsFlow();
        // Reset outer click
        setIsOuterClick(false);
        if (currentDrawer) {
            setCurrentDrawer('');
        }
        setOpen(false);
        suspendCartCheck();
        setIsConfirmation(false);
        setIsSurvey(false);
        if (isAddressChangeConfirmed) {
            setIsAddressChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
        else {
            setChangeFormValues();
        }
    };
    var goBack = function () {
        if (isChangeForm) {
            // Back to the address list when feature is enabled
            if (FeatureSwitches.enableEditDeliveryAddressAppify && !isAddressList) {
                setIsAddressList(true);
                return;
            }
            resetBodfsFlow();
            // Back to review your options
            if (currentDrawer) {
                setCurrentDrawer('');
                return;
            }
        }
        if (isConfirmation) {
            goBackToDeliveryDetails(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        // STH or BODFS flow
        if (FeatureSwitches.isSFBLEnabled && !currentDrawer && isDeliveryDetails) {
            resetBodfsFlow();
            goBackToDeliveryOptions(suspendCartCheck, setIsDeliveryOptions, setIsDeliveryDetails);
            return;
        }
        if (isDeliveryDetails) {
            resetBodfsFlow();
            goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        if (isDeliveryOptions) {
            goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
            setIsDeliveryOptions(false);
            setIsLoading(false);
            return;
        }
        closeDrawer();
    };
    useEffect(function () {
        var _a;
        if (editDeliveryAddressAlert) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editDeliveryAddressAlert', JSON.stringify(editDeliveryAddressAlert));
        }
    }, [editDeliveryAddressAlert]);
    useEffect(function () {
        var _a;
        if (currentDrawer === 'STH_DELIVERY_OPTION') {
            TrackBopisOosrAnalytics('out of stock review your options: switch to delivery', 'overlay');
        }
        setChangeFormValues();
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        var _a;
        if (updatedAddressData) {
            setSuspendCartData({
                cartId: updatedAddressData.ordersInfo.data.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
                flowType: flowType,
                fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
                    undefined,
            });
        }
    }, [updatedAddressData]);
    useEffect(function () {
        if (isOuterClick) {
            closeDrawer();
        }
    }, [isOuterClick]);
    var handleDrawerHeader = function () {
        if (isConfirmation) {
            return 'Confirm Delivery Address';
        }
        if (isDeliveryDetails) {
            return 'Delivery Details';
        }
        if (isBopisOutOfStock) {
            return isAddressList
                ? 'Choose Delivery Address'
                : 'Add New Delivery Address';
        }
        if (isChangeForm && FeatureSwitches.enableEditDeliveryAddressAppify) {
            return isAddressList
                ? 'Choose New Delivery Address'
                : 'Add New Delivery Address';
        }
        if (isDeliveryOptions && FeatureSwitches.isSFBLEnabled) {
            return 'Delivery Options';
        }
        return 'Edit Delivery Address';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { title: handleDrawerHeader(), endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: function () { return closeDrawer(); }, icon: Close }), startAdornment: (!isChangeForm ||
                currentDrawer ||
                (FeatureSwitches.enableEditDeliveryAddressAppify &&
                    !isAddressList)) &&
                !isSurvey && (React.createElement(IconButton, { "aria-label": "go-back", onClick: function () { return goBack(); }, icon: ArrowBack })) }),
        isChangeForm && (React.createElement(EditDeliveryAddressChangeForm, { firstNameValue: firstNameValue, setFirstName: setFirstName, lastNameValue: lastNameValue, setLastName: setLastName, streetAddressValue: streetAddressValue, setStreetAddress: setStreetAddress, addressLineTwoValue: addressLineTwoValue, setAddressLineTwo: setAddressLineTwo, zipCodeValue: zipCodeValue, setZipCode: setZipCode, cityStateValue: cityStateValue, setCityState: setCityState, phoneNumberValue: phoneNumberValue, setPhoneNumber: setPhoneNumber, previousCountry: country || '', closeDrawer: closeDrawer, setIsChangeForm: setIsChangeForm, enteredEditFlow: enteredEditFlow, setEnteredEditFlow: setEnteredEditFlow, setShowDrawerError: setShowDrawerError, setIsDeliveryDetails: setIsDeliveryDetails, setUpdatedAddressData: setUpdatedAddressData, setNewDeliveryAddressDetails: setNewDeliveryAddressDetails, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, setIsAddressList: setIsAddressList, isAddressList: isAddressList, isDefaultValue: isDefaultValue, setIsDefault: setIsDefault, setIsLoading: setIsLoading, isLoading: isLoading, isExcludedAddress: isExcludedAddress, setIsExcludedAddress: setIsExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, submitCreateForm: submitCreateForm, setSubmitCreateForm: setSubmitCreateForm, setIsAddNewAddressFlow: setIsAddNewAddressFlow, validationEt: validationEt, setValidationEt: setValidationEt, setIsDeliveryOptions: setIsDeliveryOptions })),
        isDeliveryDetails && (React.createElement(EditDeliveryAddressDeliveryDetails, { updatedAddressData: updatedAddressData, setUpdatedAddressData: setUpdatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsDeliveryDetails: setIsDeliveryDetails, isDeliveryDetails: isDeliveryDetails, suspendCartCheck: suspendCartCheck, setIsLoading: setIsLoading, setShowDrawerError: setShowDrawerError, setIsExcludedAddress: setIsExcludedAddress, setIsValidated: setIsValidated, closeDrawer: closeDrawer, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, traceId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, resetBodfsFlow: resetBodfsFlow, selectedDeliveryOptionType: selectedDeliveryOptionType })),
        isConfirmation &&
            updatedAddressData &&
            ((selectedDeliveryOptionType !== null && selectedDeliveryOptionType !== void 0 ? selectedDeliveryOptionType : fulfillmentGroup.fulfillmentType) ===
                FULFILLMENT_TYPE.BODFS ? (React.createElement(EditDeliveryAddressConfirmationBODFS, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, setShowDrawerError: setShowDrawerError, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed, setIsDeliveryDetails: setIsDeliveryDetails, setSubmitCreateForm: setSubmitCreateForm, resetBodfsFlow: resetBodfsFlow })) : (React.createElement(EditDeliveryAddressConfirmation, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, isDeliveryDetails: isDeliveryDetails, setShowDrawerError: setShowDrawerError, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed, resetBodfsFlow: resetBodfsFlow, isAddNewAddressFlow: isAddNewAddressFlow }))),
        isDeliveryOptions && FeatureSwitches.isSFBLEnabled && (React.createElement(EditDeliveryAddressDeliveryOptions, { closeDrawer: closeDrawer, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, newDeliveryAddressDetails: newDeliveryAddressDetails, isAddingNewAddress: Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) &&
                !isAddressList, isDefaultValue: isDefaultValue, isLoading: isLoading, setIsChangeForm: setIsChangeForm, setIsDeliveryOptions: setIsDeliveryOptions, setIsDeliveryDetails: setIsDeliveryDetails, setIsLoading: setIsLoading, setIsExcludedAddress: setIsExcludedAddress, setIsValidated: setIsValidated, setUpdatedAddressData: setUpdatedAddressData, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, setSelectedDeliveryOptionType: setSelectedDeliveryOptionType })),
        isSurvey && (React.createElement(EditDeliveryAddressSurvey, { closeDrawer: closeDrawer, selectedDeliveryOptionType: selectedDeliveryOptionType, newOrderId: editDeliveryAddressAlert === null || editDeliveryAddressAlert === void 0 ? void 0 : editDeliveryAddressAlert.newOrderId, isBopisOutOfStock: isBopisOutOfStock }))));
};
